(function () {
  function initWiring(section) {
    var sidebar = section.querySelector('[data-wiring-sidebar]');
    var trigger = section.querySelector('[data-wiring-open-filters]');
    var scrim = section.querySelector('.excel-wiring__scrim');
    var closeButton = section.querySelector('.excel-wiring__filter-close');
    var previousOverflow = '';

    function closeFilters() {
      if (!sidebar || !sidebar.classList.contains('is-open')) return;
      sidebar.classList.remove('is-open');
      scrim.classList.remove('is-open');
      scrim.hidden = true;
      trigger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = previousOverflow;
      trigger.focus();
    }

    if (trigger && sidebar && scrim) {
      trigger.addEventListener('click', function () {
        previousOverflow = document.body.style.overflow;
        sidebar.classList.add('is-open');
        scrim.hidden = false;
        scrim.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
        document.body.style.overflow = 'hidden';
        closeButton.focus();
      });
      section.querySelectorAll('[data-wiring-close-filters]').forEach(function (element) {
        element.addEventListener('click', closeFilters);
      });
      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') closeFilters();
        if (event.key === 'Tab' && sidebar.classList.contains('is-open')) {
          var focusable = Array.prototype.slice.call(sidebar.querySelectorAll('a, button, input, select, summary'))
            .filter(function (element) { return !element.disabled && element.getClientRects().length > 0; });
          if (!focusable.length) return;
          var first = focusable[0];
          var last = focusable[focusable.length - 1];
          if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
          } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
          }
        }
      });
      window.matchMedia('(min-width: 1280px)').addEventListener('change', function (event) {
        if (event.matches) closeFilters();
      });
    }

    var filterForm = section.querySelector('[data-wiring-filter-form]');
    var sortSelect = section.querySelector('[data-wiring-sort]');
    var results = section.querySelector('[data-wiring-results]');
    var count = section.querySelector('[data-wiring-count]');
    var loading = null;
    var shownSearch = window.location.search;
    var more = null;
    var moreObserver = null;
    var moreLoading = null;

    // Filters, sorting and paging load only this section and swap the results in place.
    function cleanUrl(url) {
      var next = new URL(url, window.location.href);
      next.searchParams.delete('section_id');
      return next;
    }

    // The drawer's button closes the drawer once results are already showing.
    function labelApplyButton() {
      var applyButton = filterForm.querySelector('[data-wiring-apply]');
      if (applyButton && applyButton.dataset.jsLabel) applyButton.textContent = applyButton.dataset.jsLabel;
    }

    function inputKey(input) {
      return input.type === 'checkbox' ? input.name + '=' + input.value : input.name;
    }

    // Update the existing inputs in place so open groups, "show more" and keyboard focus stay put.
    // Shopify can reorder filter values between renders, so inputs are matched by name and value.
    function syncFilters(nextForm) {
      var current = {};
      var currentInputs = filterForm.querySelectorAll('input');
      var incoming = nextForm.querySelectorAll('input');
      var pairs = [];
      currentInputs.forEach(function (input) {
        (current[inputKey(input)] = current[inputKey(input)] || []).push(input);
      });
      var matched = currentInputs.length === incoming.length && Array.prototype.every.call(incoming, function (input) {
        var match = (current[inputKey(input)] || []).shift();
        if (match) pairs.push([match, input]);
        return Boolean(match);
      });
      if (!matched) {
        filterForm.innerHTML = nextForm.innerHTML;
        labelApplyButton();
        return;
      }
      pairs.forEach(function (pair) {
        pair[0].checked = pair[1].checked;
        pair[0].disabled = pair[1].disabled;
        if (pair[0].type !== 'checkbox') pair[0].value = pair[1].value;
      });
    }

    function render(next) {
      var nextResults = next.querySelector('[data-wiring-results]');
      var nextForm = next.querySelector('[data-wiring-filter-form]');
      var nextCount = next.querySelector('[data-wiring-count]');
      var nextSort = next.querySelector('[data-wiring-sort]');
      results.innerHTML = nextResults.innerHTML;
      results.querySelectorAll('a[data-wiring-nav]').forEach(function (link) {
        link.href = cleanUrl(link.href).toString();
      });
      if (filterForm && nextForm) syncFilters(nextForm);
      if (count && nextCount) count.textContent = nextCount.textContent;
      if (sortSelect && nextSort) sortSelect.value = nextSort.value;
      results.querySelectorAll('[data-wiring-product]').forEach(initProduct);
      setupMore();
    }

    // The list keeps loading as it scrolls: once the end comes within reach, the next page's
    // rows are added to the table. The button below the list does the same for keyboard users.
    function updateShowing() {
      var showing = results.querySelector('[data-wiring-showing]');
      if (!showing || !showing.dataset.template) return;
      var last = Number(showing.dataset.offset || 0) + results.querySelectorAll('[data-wiring-product]').length;
      showing.textContent = showing.dataset.template.replace('__last__', last.toLocaleString());
    }

    function setupMore() {
      if (moreObserver) moreObserver.disconnect();
      if (moreLoading) moreLoading.abort();
      moreObserver = null;
      moreLoading = null;
      more = results.querySelector('[data-wiring-more]');
      updateShowing();
      if (!more) return;
      more.hidden = false;
      if ('IntersectionObserver' in window) {
        moreObserver = new IntersectionObserver(function (entries) {
          if (entries.some(function (entry) { return entry.isIntersecting; })) loadMore();
        }, { rootMargin: '0px 0px 800px 0px' });
        moreObserver.observe(more);
      }
    }

    function finishMore() {
      if (moreObserver) moreObserver.disconnect();
      moreObserver = null;
      if (more) more.remove();
      more = null;
    }

    function loadMore() {
      if (!more || moreLoading || loading || !more.dataset.nextUrl) return;
      var status = more.querySelector('[data-wiring-more-status]');
      var request = cleanUrl(more.dataset.nextUrl);
      request.searchParams.set('section_id', section.dataset.sectionId);
      var controller = moreLoading = new AbortController();
      more.classList.add('is-loading');
      more.classList.remove('is-error');
      status.textContent = more.dataset.loadingLabel;

      fetch(request.toString(), { credentials: 'same-origin', signal: controller.signal })
        .then(function (response) {
          if (!response.ok) throw new Error('More wiring results failed to load');
          return response.text();
        })
        .then(function (html) {
          if (moreLoading !== controller) return;
          var next = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-excel-wiring]');
          var table = results.querySelector('.excel-wiring__table');
          if (!next || !table) throw new Error('More wiring results missing');
          next.querySelectorAll('[data-wiring-product]').forEach(function (row) {
            if (table.querySelector('[data-product-id="' + row.dataset.productId + '"]')) return;
            table.appendChild(row);
            initProduct(row);
          });
          var nextMore = next.querySelector('[data-wiring-more]');
          moreLoading = null;
          more.classList.remove('is-loading');
          status.textContent = '';
          if (nextMore && nextMore.dataset.nextUrl) more.dataset.nextUrl = cleanUrl(nextMore.dataset.nextUrl).toString();
          else finishMore();
          updateShowing();
          // Short pages can leave the end of the list in view, which the observer won't report again.
          if (more && more.getBoundingClientRect().top < window.innerHeight + 800) loadMore();
        })
        .catch(function (error) {
          if (moreLoading !== controller) return;
          moreLoading = null;
          if (error.name === 'AbortError' || !more) return;
          more.classList.remove('is-loading');
          more.classList.add('is-error');
          status.textContent = more.dataset.errorLabel;
        });
    }

    function load(url, options) {
      var target = cleanUrl(url);
      var request = new URL(target);
      request.searchParams.set('section_id', section.dataset.sectionId);
      if (loading) loading.abort();
      if (moreLoading) moreLoading.abort();
      var controller = loading = new AbortController();
      section.classList.add('is-loading');
      results.setAttribute('aria-busy', 'true');

      return fetch(request.toString(), { credentials: 'same-origin', signal: controller.signal })
        .then(function (response) {
          if (!response.ok) throw new Error('Wiring results failed to load');
          return response.text();
        })
        .then(function (html) {
          var next = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-excel-wiring]');
          if (!next || !next.querySelector('[data-wiring-results]')) throw new Error('Wiring results missing');
          render(next);
          shownSearch = target.search;
          if (options.push) window.history.pushState({ excelWiring: true }, '', target.toString());
          if (options.scroll) {
            var top = section.getBoundingClientRect().top;
            if (top < 0) section.scrollIntoView({ block: 'start' });
          }
        })
        .catch(function (error) {
          if (error.name !== 'AbortError') window.location.assign(target.toString());
        })
        .finally(function () {
          if (loading !== controller) return;
          loading = null;
          section.classList.remove('is-loading');
          results.removeAttribute('aria-busy');
        });
    }

    function filterUrl() {
      var url = new URL(filterForm.action, window.location.href);
      new FormData(filterForm).forEach(function (value, key) {
        if (value !== '') url.searchParams.append(key, value);
      });
      return url;
    }

    if (!section.dataset.sectionId || !results || !window.fetch || !window.DOMParser) {
      section.querySelectorAll('[data-wiring-product]').forEach(initProduct);
      return;
    }

    if (filterForm) {
      labelApplyButton();
      filterForm.addEventListener('change', function (event) {
        if (event.target.type === 'checkbox') load(filterUrl(), { push: true });
      });
      // Results are already current, so the drawer's button just closes it.
      filterForm.addEventListener('submit', function (event) {
        event.preventDefault();
        var url = filterUrl();
        if (url.search !== window.location.search) load(url, { push: true });
        closeFilters();
      });
    }

    if (sortSelect) {
      sortSelect.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sortSelect.value);
        url.searchParams.delete('page');
        load(url, { push: true });
      });
      var sortForm = sortSelect.form;
      if (sortForm) sortForm.addEventListener('submit', function (event) { event.preventDefault(); });
    }

    section.addEventListener('click', function (event) {
      var showMore = event.target.closest('[data-wiring-show-more]');
      if (showMore) {
        var group = showMore.closest('[data-wiring-filter-group]');
        var text = showMore.querySelector('[data-wiring-show-more-text]');
        var expanded = group.classList.toggle('is-expanded');
        var label = expanded ? showMore.dataset.lessLabel : showMore.dataset.moreLabel;
        showMore.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        if (text) text.textContent = label;
        else showMore.setAttribute('aria-label', label);
        return;
      }

      if (event.target.closest('[data-wiring-more-button]')) {
        loadMore();
        return;
      }

      var link = event.target.closest('a[data-wiring-nav]');
      if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      load(link.href, { push: true, scroll: Boolean(link.closest('[data-wiring-results]')) });
    });

    window.addEventListener('popstate', function () {
      if (window.location.search !== shownSearch) load(window.location.href, { push: false });
    });

    section.classList.add('is-infinite');
    section.querySelectorAll('[data-wiring-product]').forEach(initProduct);
    setupMore();
  }

  function initProduct(row) {
    var form = row.querySelector('.excel-wiring__buy-form');
    var choices = Array.prototype.slice.call(row.querySelectorAll('[data-wiring-length]'));
    var customTrigger = row.querySelector('[data-wiring-custom-trigger]');
    var customInput = row.querySelector('[data-wiring-custom-input]');
    var lengthHelp = row.querySelector('[data-wiring-length-help]');
    var variantField = row.querySelector('[data-wiring-variant-id]');
    var cartQuantity = row.querySelector('[data-wiring-cart-quantity]');
    var cutLength = row.querySelector('[data-wiring-cut-length]');
    var cutCount = row.querySelector('[data-wiring-cut-count]');
    var quantity = row.querySelector('[data-wiring-quantity]');
    var priceValue = row.querySelector('[data-wiring-price-value]');
    var priceUnit = row.querySelector('[data-wiring-price-unit]');
    var priceTotal = row.querySelector('[data-wiring-price-total]');
    var priceTotalLine = row.querySelector('[data-wiring-price-total-line]');
    var priceFor = row.querySelector('[data-wiring-price-for]');
    // Only trade accounts get Add to Cart; everyone else gets Sign in for wiring in its place.
    var addButton = row.querySelector('[data-wiring-add]');
    var tradeLink = row.querySelector('[data-wire-trade]');
    var addLabel = addButton ? addButton.querySelector('[data-wiring-add-label]') || addButton : null;
    var quoteLink = row.querySelector('[data-wiring-quote]');
    var steps = Array.prototype.slice.call(row.querySelectorAll('[data-wiring-step]'));
    var lengthGroup = row.querySelector('.excel-wiring__lengths');
    var stepper = row.querySelector('.excel-wiring__stepper');
    var priceCuts = row.querySelector('[data-wiring-price-cuts]');
    var spliceToggle = row.querySelector('[data-wiring-splice-toggle]');
    var spliceClose = row.querySelector('[data-wiring-splice-close]');
    var spliceSummary = row.querySelector('[data-wiring-splice-summary]');
    var splice = row.querySelector('[data-wiring-splice]');
    var spliceCuts = row.querySelector('[data-wiring-splice-cuts]');
    var spliceAdd = row.querySelector('[data-wiring-splice-add]');
    var spliceCart = row.querySelector('[data-wiring-splice-cart]');
    var spliceCartLabel = row.querySelector('[data-wiring-splice-cart-label]');
    var maxCuts = Number(splice.dataset.maxCuts) || 25;
    var currentChoice = choices.filter(function (choice) { return choice.getAttribute('aria-pressed') === 'true'; })[0] || choices[0];
    var initialChoice = currentChoice;
    var lastPreset = currentChoice;
    var customOpen = false;
    // splicing: the cut card is open and the order is split into cuts.
    var splicing = false;
    var spliceMoving = false;
    var spliceGroup = newSpliceGroup();
    var addDisabled = addButton ? addButton.disabled : true;

    function feet(value) {
      var text = String(value || '').trim();
      if (!/^[1-9][0-9]*$/.test(text)) return 0;
      var amount = Number(text);
      return Number.isSafeInteger(amount) && amount <= 100000 ? amount : 0;
    }

    function cuts() {
      var text = String(quantity.value || '').trim();
      if (!/^[1-9][0-9]*$/.test(text)) return 0;
      var amount = Number(text);
      return Number.isSafeInteger(amount) && amount <= 999 ? amount : 0;
    }

    function money(cents) {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
          style: 'currency',
          currency: row.dataset.currency || 'USD'
        }).format(cents / 100);
      } catch (error) {
        return '$' + (cents / 100).toFixed(2);
      }
    }

    // Show the total footage (3 cuts of 500 ft reads "1,500 ft").
    function cutText(totalFeet) {
      return totalFeet.toLocaleString() + ' ft';
    }

    function cutCountText(count) {
      return count === 1 ? row.dataset.cutOne : row.dataset.cutMany.replace('[count]', count.toLocaleString());
    }

    // Splice mode: each filled cut field is one cut. Empty fields are skipped; anything else
    // that isn't a whole number of feet makes the order invalid until it's fixed.
    function cutInputs() {
      return Array.prototype.slice.call(spliceCuts.querySelectorAll('[data-wiring-splice-input]'));
    }

    function spliceLengths() {
      var lengths = [];
      var valid = true;
      cutInputs().forEach(function (input) {
        if (input.value === '') {
          input.setAttribute('aria-invalid', 'false');
          return;
        }
        var length = feet(input.value);
        input.setAttribute('aria-invalid', length ? 'false' : 'true');
        if (!length) valid = false;
        lengths.push(length);
      });
      return { lengths: lengths, valid: valid && lengths.length > 0 };
    }

    function labelCuts() {
      var inputs = cutInputs();
      inputs.forEach(function (input, index) {
        var field = input.closest('.excel-wiring__splice-cut');
        var number = String(index + 1);
        field.querySelector('.excel-wiring__splice-label').textContent = splice.dataset.cutLabel.replace('[n]', number);
        var remove = field.querySelector('[data-wiring-splice-remove]');
        remove.setAttribute('aria-label', splice.dataset.removeLabel.replace('[n]', number));
        remove.hidden = inputs.length <= 1;
      });
      spliceAdd.hidden = inputs.length >= maxCuts;
    }

    // Each cut is an outlined field: the "Cut 1" label sits on the outline, with ft and remove inside.
    function addCut(value) {
      var field = document.createElement('div');
      field.className = 'excel-wiring__splice-cut';
      var label = document.createElement('label');
      label.className = 'excel-wiring__splice-field';
      var name = document.createElement('span');
      name.className = 'excel-wiring__splice-label';
      var input = document.createElement('input');
      input.type = 'text';
      input.inputMode = 'numeric';
      input.pattern = '[0-9]*';
      input.maxLength = 6;
      input.autocomplete = 'off';
      input.setAttribute('data-wiring-splice-input', '');
      input.value = value ? String(value) : '';
      var unit = document.createElement('span');
      unit.className = 'excel-wiring__splice-unit';
      unit.setAttribute('aria-hidden', 'true');
      unit.textContent = 'ft';
      var remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'excel-wiring__splice-remove';
      remove.setAttribute('data-wiring-splice-remove', '');
      remove.tabIndex = -1;
      remove.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M18 6 6 18M6 6l12 12"/></svg>';
      label.appendChild(name);
      label.appendChild(input);
      label.appendChild(unit);
      field.appendChild(label);
      field.appendChild(remove);
      spliceCuts.appendChild(field);
      return input;
    }

    // Material 3 motion: emphasized decelerate to enter, emphasized accelerate to leave.
    // Exits hold their last frame until the element is hidden, so nothing flashes back.
    var motionEnter = 'cubic-bezier(.05, .7, .1, 1)';
    var motionExit = 'cubic-bezier(.3, 0, .8, .15)';
    var reducedMotion = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;

    function motion(element, keyframes, options) {
      if (!element || !element.animate || (reducedMotion && reducedMotion.matches)) return Promise.resolve(null);
      var animation = element.animate(keyframes, options);
      return animation.finished.then(function () { return animation; }, function () { return null; });
    }

    // The card unfolds from the Splice chip's corner, then its header, cuts and buttons rise in turn.
    function revealCard() {
      motion(splice, [
        { opacity: 0, transform: 'translateY(-6px) scale(.96)', clipPath: 'inset(0 0 70% 0 round 12px)' },
        { opacity: 1, offset: 0.35 },
        { opacity: 1, transform: 'none', clipPath: 'inset(0 0 0% 0 round 12px)' }
      ], { duration: 420, easing: motionEnter });
      var parts = [splice.querySelector('.excel-wiring__splice-head')]
        .concat(Array.prototype.slice.call(spliceCuts.children))
        .concat([splice.querySelector('.excel-wiring__splice-foot')]);
      parts.forEach(function (part, index) {
        motion(part, [
          { opacity: 0, transform: 'translateY(8px)' },
          { opacity: 1, transform: 'none' }
        ], { duration: 320, delay: 70 + index * 40, easing: motionEnter, fill: 'backwards' });
      });
    }

    function foldCard() {
      return motion(splice, [
        { opacity: 1, transform: 'none', clipPath: 'inset(0 0 0% 0 round 12px)' },
        { opacity: 0, transform: 'translateY(-4px) scale(.98)', clipPath: 'inset(0 0 60% 0 round 12px)' }
      ], { duration: 200, easing: motionExit, fill: 'forwards' });
    }

    function enter(element) {
      motion(element, [
        { opacity: 0, transform: 'scale(.97)' },
        { opacity: 1, transform: 'none' }
      ], { duration: 280, easing: motionEnter });
    }

    // Splice starts as two cuts: the length split in half (75 ft becomes 38 + 37), so the total and
    // price don't change. The length is the custom one, or the selected preset when nothing's typed;
    // either way the row switches to a custom cut. Several identical cuts each get their own field.
    function openSplice(event) {
      var length = customOpen ? feet(customInput.value) : feet(currentChoice.dataset.length);
      var pieces = cuts() || 1;
      if (!customOpen) {
        currentChoice = customTrigger;
        customOpen = true;
        customTrigger.classList.add('is-active');
        choices.forEach(function (button) {
          button.classList.remove('is-selected');
          button.setAttribute('aria-pressed', 'false');
        });
      }
      customInput.value = length ? String(length) : '';
      var values = [Math.ceil(length / 2), Math.floor(length / 2)];
      if (pieces > 1) {
        values = [];
        for (var index = 0; index < Math.min(pieces, maxCuts); index += 1) values.push(length);
      }
      spliceCuts.innerHTML = '';
      values.forEach(function (value) { addCut(value || ''); });
      splicing = true;
      labelCuts();
      update();
      revealCard();
      focusCard(event);
    }

    // Keyboard users land in the first cut; a tap or click doesn't pop up the phone keyboard.
    function focusCard(event) {
      if (event && event.detail === 0) cutInputs()[0].focus();
      else splice.focus({ preventScroll: true });
    }

    // The card's Add to Cart adds the cuts (each its own cart line), then folds the card away and
    // puts the row back the way the page loaded it. The cart popup reads the form as it submits,
    // so the reset can't change what was added. A cut that isn't a whole number keeps the card open.
    function addSplice() {
      if (spliceMoving || spliceCart.disabled) return;
      var invalid = cutInputs().filter(function (input) { return input.getAttribute('aria-invalid') === 'true'; })[0];
      if (invalid) {
        invalid.focus();
        return;
      }
      update();
      if (!quoteLink.hidden) {
        window.location.assign(quoteLink.href);
        return;
      }
      if (!addButton || addButton.disabled) return;
      addButton.click();
      spliceMoving = true;
      foldCard().then(function (animation) {
        spliceMoving = false;
        quantity.value = '1';
        select(initialChoice);
        if (animation) animation.cancel();
        enter(lengthGroup);
      });
    }

    // Back to one cut: the first filled cut becomes the custom length again.
    function closeSplice() {
      if (spliceMoving) return;
      var first = cutInputs().filter(function (input) { return feet(input.value) > 0; })[0];
      spliceMoving = true;
      foldCard().then(function (animation) {
        spliceMoving = false;
        splicing = false;
        spliceCuts.innerHTML = '';
        quantity.value = '1';
        if (first) customInput.value = first.value;
        update();
        if (animation) animation.cancel();
        enter(lengthGroup);
        customInput.focus();
      });
    }

    // The total footage (or a prompt when the length or cuts are missing), then the line total.
    // Leave totalCents null to hide the total line.
    function showTotal(totalCents, text, prompt) {
      priceTotalLine.hidden = totalCents === null;
      priceTotal.textContent = totalCents === null ? '' : money(totalCents);
      priceFor.textContent = text;
      priceFor.classList.toggle('is-prompt', Boolean(prompt));
    }

    function newSpliceGroup() {
      return Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
    }

    // One cart line per cut. "Splice cut" keeps identical lengths on their own lines, and the hidden
    // group id (renewed on every Add to Cart) keeps a repeat add from merging into earlier lines.
    // Shopify lists the newest line first, so the cuts are sent last to first to read Cut 1 at the top.
    function spliceLines(lengths, variantId) {
      return lengths.map(function (length, index) {
        return {
          id: Number(variantId),
          quantity: length,
          properties: {
            'Cut length': length + ' ft',
            'Number of cuts': '1',
            'Splice cut': (index + 1) + ' of ' + lengths.length,
            '_Splice group': spliceGroup
          }
        };
      }).reverse();
    }

    function update() {
      var choice = currentChoice;
      var mode = choice.dataset.mode;
      var spliceState = splicing ? spliceLengths() : null;
      var length = splicing ? 0 : customOpen ? feet(customInput.value) : feet(choice.dataset.length);
      var pieces = splicing ? spliceState.lengths.length : cuts();
      var totalFeet = splicing ? spliceState.lengths.reduce(function (sum, cut) { return sum + cut; }, 0) : length * pieces;
      var units = mode === 'foot' ? totalFeet : pieces;
      var lengthValid = splicing ? spliceState.valid : length > 0;
      var quantityValid = pieces > 0;
      var withinLimit = units <= 999999;
      var valid = lengthValid && quantityValid && withinLimit;
      var available = choice.dataset.available === 'true';
      var inventoryLimited = choice.dataset.inventoryManaged === 'true' && choice.dataset.inventoryPolicy === 'deny';
      var enoughInventory = !inventoryLimited || units <= Number(choice.dataset.inventory || 0);

      variantField.value = choice.dataset.variantId || '';
      cartQuantity.value = String(valid ? units : 1);
      cutLength.disabled = mode !== 'foot' || !valid;
      cutCount.disabled = mode !== 'foot' || !valid;
      cutLength.value = splicing ? spliceState.lengths.map(function (cut) { return cut + ' ft'; }).join(', ') : length + ' ft';
      cutCount.value = String(pieces);
      if (splicing && valid && mode === 'foot' && pieces > 1 && variantField.value) form.dataset.cartLines = JSON.stringify(spliceLines(spliceState.lengths, variantField.value));
      else delete form.dataset.cartLines;

      var priceCents = Number(choice.dataset.priceCents);
      var countValid = lengthValid && quantityValid;
      if (mode === 'foot') {
        priceValue.textContent = money(priceCents);
        priceUnit.hidden = false;
        if (countValid) showTotal(priceCents * totalFeet, cutText(totalFeet));
        else showTotal(null, lengthValid ? row.dataset.enterCuts : row.dataset.enterFeet, true);
      } else if (mode === 'variant') {
        priceValue.textContent = lengthValid ? money(Math.round(priceCents / length)) : money(priceCents);
        priceUnit.hidden = !lengthValid;
        if (countValid) showTotal(priceCents * pieces, cutText(totalFeet));
        else showTotal(null, row.dataset.enterCuts, true);
      } else {
        priceValue.textContent = row.dataset.priceRequest;
        priceUnit.hidden = true;
        showTotal(null, lengthValid ? cutText(splicing ? totalFeet : length * (pieces || 1)) : row.dataset.enterFeet, !lengthValid);
      }
      customTrigger.classList.toggle('is-custom-cut', customOpen && lengthValid && mode === 'foot');

      // A custom length or splice notes its cut count on the total line.
      var customValid = customOpen && feet(customInput.value) > 0;
      var showCuts = splicing ? pieces > 0 : customValid && quantityValid;
      priceCuts.textContent = showCuts ? cutCountText(pieces) : '';
      priceCuts.hidden = !showCuts;
      spliceSummary.textContent = splicing && pieces ? cutCountText(pieces) + (lengthValid ? ' · ' + cutText(totalFeet) : '') : '';
      spliceToggle.setAttribute('aria-expanded', splicing ? 'true' : 'false');
      splice.hidden = !splicing;
      lengthGroup.hidden = splicing;
      stepper.hidden = splicing;
      row.classList.toggle('is-splicing', splicing);

      customInput.setAttribute('aria-invalid', customOpen && !splicing && !lengthValid ? 'true' : 'false');
      lengthHelp.hidden = !(customOpen || splicing) || lengthValid || (splicing && pieces === 0);
      quantity.setAttribute('aria-invalid', quantityValid ? 'false' : 'true');
      steps.forEach(function (step) {
        var delta = Number(step.dataset.wiringStep);
        step.disabled = delta < 0 ? pieces <= 1 : pieces >= 999;
      });
      var needsQuote = mode === 'quote' || (available && !enoughInventory);
      quoteLink.hidden = !needsQuote || !valid;
      if (tradeLink) tradeLink.hidden = needsQuote && valid;
      addDisabled = !valid || mode === 'quote' || !available || !enoughInventory || !variantField.value;
      var specialOrder = choice.dataset.inventoryManaged === 'true' && choice.dataset.inventoryPolicy === 'continue' && units > Number(choice.dataset.inventory || 0);
      if (addButton) {
        addButton.hidden = needsQuote && valid;
        addButton.disabled = addDisabled;
        addButton.classList.toggle('is-special-order', specialOrder && !addDisabled);
        addLabel.textContent = !lengthValid ? row.dataset.enterFeet : !quantityValid || !withinLimit ? row.dataset.enterCuts : addButton.disabled ? addButton.dataset.outLabel : specialOrder ? addButton.dataset.specialLabel : addButton.dataset.addLabel;
      }

      // While the card is open, its own button stands in for Add to Cart (or Request quote).
      var quoteNext = needsQuote && valid;
      spliceCartLabel.textContent = quoteNext ? quoteLink.textContent.trim() : addLabel ? addLabel.textContent : '';
      spliceCart.disabled = !quoteNext && addDisabled;
      spliceCart.classList.toggle('is-quote', quoteNext);
      spliceCart.classList.toggle('is-special-order', !quoteNext && specialOrder && !addDisabled);

      if (needsQuote && valid) {
        var quoteUrl = new URL(row.dataset.quoteUrl, window.location.origin);
        quoteUrl.searchParams.set('product', row.dataset.productTitle);
        if (splicing) {
          quoteUrl.searchParams.delete('wire_length_ft');
          quoteUrl.searchParams.set('cut_lengths_ft', spliceState.lengths.join(','));
          quoteUrl.searchParams.set('total_ft', String(totalFeet));
        } else {
          quoteUrl.searchParams.set('wire_length_ft', String(length));
        }
        quoteUrl.searchParams.set('cuts', String(pieces));
        quoteLink.href = quoteUrl.toString();
      }
    }

    function select(choice) {
      currentChoice = choice;
      lastPreset = choice;
      customOpen = false;
      splicing = false;
      spliceCuts.innerHTML = '';
      customInput.value = '';
      customTrigger.classList.remove('is-active');
      choices.forEach(function (button) {
        var selected = button === choice;
        button.classList.toggle('is-selected', selected);
        button.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });
      update();
    }

    choices.forEach(function (choice) {
      choice.addEventListener('click', function () { select(choice); });
    });

    // Typing a length switches to the custom cut; clearing the box goes back to the last preset.
    customInput.addEventListener('input', function () {
      var digits = customInput.value.replace(/\D/g, '');
      if (digits !== customInput.value) customInput.value = digits;
      if (!digits) {
        select(lastPreset);
        return;
      }
      currentChoice = customTrigger;
      customOpen = true;
      customTrigger.classList.add('is-active');
      choices.forEach(function (button) {
        button.classList.remove('is-selected');
        button.setAttribute('aria-pressed', 'false');
      });
      update();
    });
    customInput.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        select(lastPreset);
      }
      if (event.key === 'Enter') {
        event.preventDefault();
        customInput.blur();
      }
    });

    quantity.addEventListener('input', update);
    steps.forEach(function (step) {
      step.addEventListener('click', function () {
        quantity.value = Math.min(999, Math.max(1, (cuts() || 1) + Number(step.dataset.wiringStep)));
        update();
      });
    });
    quantity.addEventListener('change', function () {
      quantity.value = cuts() || 1;
      update();
    });

    spliceToggle.addEventListener('click', openSplice);
    spliceClose.addEventListener('click', closeSplice);
    spliceCart.addEventListener('click', addSplice);
    spliceAdd.addEventListener('click', function () {
      if (cutInputs().length >= maxCuts) return;
      var input = addCut('');
      labelCuts();
      update();
      motion(input.closest('.excel-wiring__splice-cut'), [
        { opacity: 0, transform: 'scale(.9)' },
        { opacity: 1, transform: 'none' }
      ], { duration: 260, easing: motionEnter });
      input.focus();
    });
    spliceCuts.addEventListener('input', function (event) {
      var input = event.target.closest('[data-wiring-splice-input]');
      if (!input) return;
      var digits = input.value.replace(/\D/g, '');
      if (digits !== input.value) input.value = digits;
      update();
    });
    spliceCuts.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter' || !event.target.closest('[data-wiring-splice-input]')) return;
      event.preventDefault();
      event.target.blur();
    });
    spliceCuts.addEventListener('click', function (event) {
      var remove = event.target.closest('[data-wiring-splice-remove]');
      if (!remove) return;
      var field = remove.parentNode;
      if (field.classList.contains('is-leaving')) return;
      var index = cutInputs().indexOf(field.querySelector('[data-wiring-splice-input]'));
      field.classList.add('is-leaving');
      motion(field, [
        { opacity: 1, transform: 'none' },
        { opacity: 0, transform: 'scale(.9)' }
      ], { duration: 160, easing: motionExit, fill: 'forwards' }).then(function () {
        field.remove();
        labelCuts();
        update();
        var remaining = cutInputs();
        (remaining[Math.min(index, remaining.length - 1)] || spliceAdd).focus();
      });
    });

    // A fresh splice group per add, so adding the same cuts again makes new lines instead of merging.
    // Enter in a field submits through a click on this button too, so this runs before every add.
    if (addButton) addButton.addEventListener('click', function () {
      if (!splicing) return;
      spliceGroup = newSpliceGroup();
      update();
    });

    form.addEventListener('submit', function (event) {
      update();
      if (!addButton || addButton.disabled || addButton.hidden || !variantField.value) {
        event.preventDefault();
        return;
      }
      // The cart popup normally sends spliced cuts as separate lines. Without it, add them here and open the cart.
      if (!form.dataset.cartLines || !window.fetch) return;
      event.preventDefault();
      addButton.disabled = true;
      addButton.setAttribute('aria-busy', 'true');
      fetch(form.getAttribute('action').replace(/\/$/, '') + '.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: JSON.parse(form.dataset.cartLines) })
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Spliced cuts were not added');
          window.location.assign(row.dataset.cartUrl || '/cart');
        })
        .catch(function () {
          addButton.removeAttribute('aria-busy');
          addButton.disabled = addDisabled;
        });
    });

    select(currentChoice);

    // Store apps can re-enable every cart-add button; keep this row's availability state.
    if (addButton) new MutationObserver(function () {
      if (addButton.getAttribute('aria-busy') !== 'true' && addButton.disabled !== addDisabled) addButton.disabled = addDisabled;
    }).observe(addButton, { attributes: true, attributeFilter: ['disabled'] });
  }

  function start() {
    document.querySelectorAll('[data-excel-wiring]').forEach(initWiring);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
